import { useMemo } from 'react';
import {
  TimeSignalUtilization,
  useTimeSignalUtilizationAnalyticsQuery
} from 'graphql/types';
import { useNoteInsightsContext } from 'modules/Insights/Notes/NoteInsightsContextProvider';

export const useGetTimeSignalUtilizationAnalyticsData = (): {
  data: TimeSignalUtilization[];
  loading: boolean;
  isEmpty: boolean;
} => {
  const { currentPeriod } = useNoteInsightsContext();
  const { startDate, endDate } = currentPeriod ?? {};
  const { loading, data } = useTimeSignalUtilizationAnalyticsQuery({
    variables: {
      input: {
        fromDate: startDate,
        toDate: endDate
      }
    }
  });
  return useMemo(
    () => ({
      data: data?.timeSignalUtilizationAnalytics?.items || [],
      loading,
      isEmpty: data?.timeSignalUtilizationAnalytics?.items.length === 0
    }),
    [data, loading]
  );
};
